import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Check } from 'lucide-react';
import { getCurrentUser, getUserProfile } from './services/authService';

const PaymentSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    // Refresh user profile to get updated library limit
    const refreshUserProfile = async () => {
      try {
        const user = getCurrentUser();
        if (user) {
          await getUserProfile(user.uid);
          console.log('✅ User profile refreshed after payment');
        }
      } catch (error) {
        console.error('Error refreshing profile:', error);
      }
    };

    refreshUserProfile();

    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/', { state: { refreshProfile: true } });
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="croop-route-page">
      <div className="croop-route-panel">
        <div className="croop-route-brand" aria-label="Croop">
          <img className="croop-route-logo" src="/croop-horizontal.svg" alt="" />
        </div>

        <div className="croop-route-icon croop-route-icon-success">
          <Check size={46} />
        </div>

        <h1 className="croop-route-title">
          Payment successful!
        </h1>

        <p className="croop-route-copy">
          Your storage has been added to your account.
        </p>

        <p className="croop-route-subtle">
          Redirecting in {countdown} seconds...
        </p>
      </div>
    </div>
  );
};

export default PaymentSuccess;
